<template>
  <button type="button" class="google-sign-in" @click="$emit('click')">
    <svg class="google-sign-in-logo" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6C44.4 38.02 46.98 31.86 46.98 24.55z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.91-5.8l-7.73-6c-2.15 1.45-4.92 2.3-8.18 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
    <span>{{$t('continueWithGoogle')}}</span>
  </button>
</template>

<script>
export default {
  name: 'GoogleSignInButton',
};
</script>

<style scoped>
.google-sign-in {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 42px;
  padding: 10px 12px;
  border: 1px solid #dadce0;
  border-radius: 6px;
  background-color: #fff;
  color: #3c4043;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.google-sign-in:hover {
  background-color: #f8f9fa;
  border-color: #bdc1c6;
}
.google-sign-in:focus-visible {
  outline: 2px solid #4285f4;
  outline-offset: 2px;
}
.google-sign-in-logo {
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
}
</style>
